// src/pages/NotFound.jsx
import React from "react";

import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";

export default function NotFound() {
  return (
    <>
      <Header />
      <div className="bg-primary pt-5 pb-20">
        <div className="container">
          <div className="row">
           
          </div>
        </div>
      </div>
      <div className="bg-white py-3">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="card w-100 mt-n20 bg-white rounded-3 shadow-sm mb-5">
                <div className="card-body p-3">
                  <div className="">
                    <div className="d-flex flex-column justify-content-center align-items-center vh-50">
                      <h1 className="display-4 fw-bold text-danger">404</h1>
                      <p className="fs-4">Oops! Page not found.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
